export default {
  EXTERNAL: "EXTERNAL",
  CLIENT_ADMIN: "CLIENT_ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  OBSERVER: "OBSERVER",
  OBSERVER_SELLER: "OBSERVER_SELLER",
  PROSPECTING: "PROSPECTING",
};
